import React from "react";
import "../../styles/ErrorCodeChecker.css";

export default function ErrorCodeDisplay({ codes, brand, deviceType }) {
  if (!codes || codes.length === 0) return <p>No error codes found.</p>;

  return (
    <div className="error-display-wrapper">
      <div className="error-display">
        <h3>{deviceType} - {brand} Error Codes</h3>
        <table>
          <thead>
            <tr>
              <th>Error Code</th>
              <th>Meaning</th>
              <th>Recommended Action</th>
            </tr>
          </thead>
          <tbody>
            {codes.map((item, idx) => (
              <tr key={idx}>
                <td>{item.code}</td>
                <td>{item.meaning}</td>
                <td>{item.solution}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
